export default [
  {
    key: 'ctr',
    name: 'CTR',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'good_effect'
  },
  {
    key: 'ecpm',
    name: 'ECPM',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'good_effect'
  },
  {
    key: 'acp',
    name: 'ACP',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'good_effect',
    minWidth: 180
  }
];
